export default {
  props: {
    isOnWhiteCard: {
      type: Boolean,
      default: false,
    },
  },
};
